import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TranslationContainerComponent} from '../../../../components/abstract/translation-container.component';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {CameraComponent} from '../../../../components/camera/camera.component';
import {WebcamImage} from 'ngx-webcam';
import {ScrollHelper} from '../../../../services/scroll-helper';

@Component({
  selector: 'app-customer-agreement-capture',
  templateUrl: './customer-agreement-capture.component.html',
  styleUrls: []
})
export class CustomerAgreementCaptureComponent extends TranslationContainerComponent implements OnInit {

  @Output() result: EventEmitter<string|null> = new EventEmitter<string|null>();
  @ViewChild('camera') camera: CameraComponent;

  constructor() {
    super('INITIAL_DATA_SECTION.CUSTOMER_AGREEMENT_CAPTURE');
  }

  ngOnInit() {

  }

  capture(): void {
    if (isNotNullOrUndefined(this.camera)) {
      this.camera.capture();
    }
  }

  onCameraInit(): void {
    setTimeout(() => {
      (new ScrollHelper()).scrollIntoView('.customer-agreement-capture__camera-wrapper', {behavior: 'smooth'}, false);
    }, 100);
  }

  onImageCapture(data: WebcamImage): void {
    if (data) {
      this.result.emit(data.imageAsDataUrl);
    }
  }

  cancelCapture(): void {
    this.result.emit();
  }

}
